"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDownloadPopUpDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class AppDownloadPopUpDto {
    constructor(params) {
        this.downloadLink = "";
        this.mainText = "";
        this.secondaryText = "";
        this.featureText1 = "";
        this.featureText2 = "";
        this.featureText3 = "";
        this.featureText4 = "";
        this.finalText = "";
        this.featureTextColor = "";
        this.finalTextColor = "";
        this.mainTextColor = "";
        this.backgroundColor = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.expireSession = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.downloadLink = params.downloadLink;
        this.mainText = params.mainText;
        this.secondaryText = params.secondaryText;
        this.featureText1 = params.featureText1;
        this.featureText2 = params.featureText2;
        this.featureText3 = params.featureText3;
        this.featureText4 = params.featureText4;
        this.finalText = params.finalText;
        this.featureTextColor = params.featureTextColor;
        this.finalTextColor = params.finalTextColor;
        this.mainTextColor = params.mainTextColor;
        this.backgroundColor = params.backgroundColor;
        this.appId = params.appId;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.expireSession = params.expireSession;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
    }
}
exports.AppDownloadPopUpDto = AppDownloadPopUpDto;
//# sourceMappingURL=AppDownloadPopUpDto.js.map